$(document).ready(function(){
    $(document).on('change', '.quantity_selector--wrapper .customize_wrapper:not(.hidden) .quantity__input', function(){
        const __this = $(this);
        const productQty = $(this).val();
        show_discount(__this, productQty);
    });

    $(document).on('click', '.quantity_selector--wrapper .quantity-tab li', function(){
        const __this = $(this);
        const productQty = __this.closest('.quantity_selector--wrapper .customize_wrapper:not(.hidden)').find('.quantity__input').val();
        show_discount(__this, productQty);
    });

    function show_discount(__this, productQty) {
        const customerB2b = $('body').attr('data-b2b-customer');
        const porductType = $('.quantity_selector-discount-wrapper').attr('data-product-type');
        // console.log('customerB2b',customerB2b);
        if (customerB2b === "true") {
            if(__this.closest('.quantity_selector--wrapper').find('.product-form-btn').hasClass('purchase-blank')) {
                if(productQty < 6){
                    remainQty = 6 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 5%`);
                    $('.product-discount-setup-fee').html(``);
                } else if (productQty < 12) {
                    remainQty = 12 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 12%`);
                    $('.product-discount-setup-fee').html(``);
                } else if (productQty < 25) {
                    remainQty = 25 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 17%`);
                    $('.product-discount-setup-fee').html(``);
                } else if (productQty < 50) {
                    remainQty = 50 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 20%`);
                    $('.product-discount-setup-fee').html(``);
                } else if (productQty < 100) {
                    remainQty = 100 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 25%`);
                    $('.product-discount-setup-fee').html(``);
                } else if (productQty < 250) {
                    remainQty = 250 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 27%`);
                    $('.product-discount-setup-fee').html(``);
                } else if (productQty >= 250) {
                    $('.product-discount-text').html(`You are saving 27%`);
                    $('.product-discount-setup-fee').html(``);
                }
            } else {
                if(productQty < 6){
                    remainQty = 6 - productQty;
                    remainQtyCustom = 12 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 10%`);
                    $('.product-discount-setup-fee').html(`Order ${remainQtyCustom} more ${porductType} to receive free setup fee.`);
                } else if (productQty < 12) {
                    remainQty = 12 - productQty;
                    remainQtyCustom = 12 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 30%`);
                    $('.product-discount-setup-fee').html(`Order ${remainQtyCustom} more ${porductType} to receive free setup fee.`);
                } else if (productQty < 25) {
                    remainQty = 25 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 35%`);
                    $('.product-discount-setup-fee').html(`You are eligible for free set up fee.`);
                } else if (productQty < 50) {
                    remainQty = 50 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 40%`);
                    $('.product-discount-setup-fee').html(`You are eligible for free set up fee.`);
                } else if (productQty < 100) {
                    remainQty = 100 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 45%`);
                    $('.product-discount-setup-fee').html(`You are eligible for free set up fee.`);
                } else if (productQty < 250) {
                    remainQty = 250 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 50%`);
                    $('.product-discount-setup-fee').html(`You are eligible for free set up fee.`);
                } else if (productQty >= 250) {
                    $('.product-discount-text').html(`You are saving 50%`);
                    $('.product-discount-setup-fee').html(`You are eligible for free set up fee.`);
                }
            }
        } else {
            if(__this.closest('.quantity_selector--wrapper').find('.product-form-btn').hasClass('purchase-blank')) {
                if(productQty < 5){
                    remainQty = 5 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 5%`);
                    $('.product-discount-setup-fee').html(``);
                } else if (productQty < 10) {
                    remainQty = 10 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 12%`);
                    $('.product-discount-setup-fee').html(``);
                } else if (productQty < 25) {
                    remainQty = 25 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 17%`);
                    $('.product-discount-setup-fee').html(``);
                } else if (productQty < 50) {
                    remainQty = 50 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 20%`);
                    $('.product-discount-setup-fee').html(``);
                } else if (productQty < 100) {
                    remainQty = 100 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 25%`);
                    $('.product-discount-setup-fee').html(``);
                } else if (productQty < 250) {
                    remainQty = 250 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 27%`);
                    $('.product-discount-setup-fee').html(``);
                } else if (productQty < 500) {
                    remainQty = 500 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 30%`);
                    $('.product-discount-setup-fee').html(``);
                } else if (productQty >= 500) {
                    $('.product-discount-text').html(`You are saving 30%`);
                    $('.product-discount-setup-fee').html(``);
                }
            } else {
                if(productQty < 6){
                    remainQty = 6 - productQty;
                    remainQtyCustom = 10 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 10%`);
                    $('.product-discount-setup-fee').html(`Order ${remainQtyCustom} more ${porductType} to receive free setup fee.`);
                } else if (productQty < 12) {
                    remainQty = 12 - productQty;
                    remainQtyCustom = 12 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 30%`);
                    $('.product-discount-setup-fee').html(`Order ${remainQtyCustom} more ${porductType} to receive free setup fee.`);
                } else if (productQty < 25) {
                    remainQty = 25 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 35%`);
                    $('.product-discount-setup-fee').html(`You are eligible for free set up fee.`);
                } else if (productQty < 50) {
                    remainQty = 50 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 40%`);
                    $('.product-discount-setup-fee').html(`You are eligible for free set up fee.`);
                } else if (productQty < 100) {
                    remainQty = 100 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 45%`);
                    $('.product-discount-setup-fee').html(`You are eligible for free set up fee.`);
                } else if (productQty < 250) {
                    remainQty = 250 - productQty;
                    $('.product-discount-text').html(`Order ${remainQty} more ${porductType} and save 50%`);
                    $('.product-discount-setup-fee').html(`You are eligible for free set up fee.`);
                } else if (productQty >= 250) {
                    $('.product-discount-text').html(`You are saving 50%`);
                    $('.product-discount-setup-fee').html(`You are eligible for free set up fee.`);
                }
            }
        }
    }

    $(document).on('change', '.quantity_selector--wrapper .patches-block-info:not(.hidden) .quantity__input', function(){
        const __this = $(this);
        const productQty = $(this).val();
        patch_show_discount(__this, productQty);
    });

    $(document).on('click', '.quantity_selector--wrapper .patches-block-info:not(.hidden) .quantity-tab li', function(){
        const __this = $(this);
        const productQty = __this.closest('.quantity_selector--wrapper').find('.quantity__input').val();
        patch_show_discount(__this, productQty);
    });

    function patch_show_discount(__this, productQty) {
        const porductType = $('.quantity_selector-discount-wrapper').attr('data-product-type');
        if(productQty < 5){
            remainQty = 5 - productQty;
            remainQtyCustom = 10 - productQty;
            $('.patch-product-discount-text').html(`Order ${remainQty} more ${porductType} and save 10%`);
            $('.patch-product-discount-setup-fee').html(`Order ${remainQtyCustom} more ${porductType} to receive free setup fee.`);
        } else if (productQty < 10) {
            remainQty = 10 - productQty;
            remainQtyCustom = 10 - productQty;
            $('.patch-product-discount-text').html(`Order ${remainQty} more ${porductType} and save 25%`);
            $('.patch-product-discount-setup-fee').html(`Order ${remainQtyCustom} more ${porductType} to receive free setup fee.`);
        } else if (productQty < 25) {
            remainQty = 25 - productQty;
            $('.patch-product-discount-text').html(`Order ${remainQty} more ${porductType} and save 35%`);
            $('.patch-product-discount-setup-fee').html(`You are eligible for free set up fee.`);
        } else if (productQty < 50) {
            remainQty = 50 - productQty;
            $('.patch-product-discount-text').html(`Order ${remainQty} more ${porductType} and save 40%`);
            $('.patch-product-discount-setup-fee').html(`You are eligible for free set up fee.`);
        } else if (productQty < 100) {
            remainQty = 100 - productQty;
            $('.patch-product-discount-text').html(`Order ${remainQty} more ${porductType} and save 50%`);
            $('.patch-product-discount-setup-fee').html(`You are eligible for free set up fee.`);
        } else if (productQty < 250) {
            remainQty = 250 - productQty;
            $('.patch-product-discount-text').html(`Order ${remainQty} more ${porductType} and save 55%`);
            $('.patch-product-discount-setup-fee').html(`You are eligible for free set up fee.`);
        } else if (productQty < 500) {
            remainQty = 500 - productQty;
            $('.patch-product-discount-text').html(`Order ${remainQty} more ${porductType} and save 60%`);
            $('.patch-product-discount-setup-fee').html(`You are eligible for free set up fee.`);
        } else if (productQty >= 500) {
            $('.patch-product-discount-text').html(`You are saving 60%`);
            $('.patch-product-discount-setup-fee').html(`You are eligible for free set up fee.`);
        }
    }
});